import type { IssueQuery, SearchWorkItemsFilters } from './types';

export function issueSearchParams(query: IssueQuery): URLSearchParams {
  const params = new URLSearchParams({ owner: query.scope.owner });
  if (query.scope.project) params.set('project', query.scope.project);
  if (query.scope.repo) params.set('repo', query.scope.repo);
  const keys = [
    'state',
    'q',
    'label',
    'assignee',
    'board',
    'sprint',
    'page',
  ] as const;
  for (const key of keys) {
    if (query[key]) params.set(key, query[key]);
  }
  if (query.pageSize !== undefined)
    params.set('pageSize', String(query.pageSize));
  return params;
}

export function workItemQuery(
  filters?: Omit<SearchWorkItemsFilters, 'projectId'>,
): string {
  const params = new URLSearchParams();
  if (filters?.types?.length) params.set('types', filters.types.join(','));
  if (filters?.states?.length) params.set('states', filters.states.join(','));
  if (filters?.assignedToMe) params.set('assignedToMe', 'true');
  const keys = [
    'text',
    'workItemId',
    'areaPath',
    'iterationPath',
    'top',
    'skip',
  ] as const;
  for (const key of keys) {
    const value = filters?.[key];
    if (value) params.set(key, String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : '';
}
